import control from './audit-trail-service';

let service = null;
function getInstance() {
    service = service || control.createService();
    return service;
}

function showRecordHistory(idStr, tableCode){
    getInstance().openDialog(idStr, tableCode);
}
export default {
    install(vue){
        if(typeof window !=='undefined'){
            window.showRecordHistory = showRecordHistory;
        }
        vue.prototype.showRecordHistory = showRecordHistory;
    }
};
